import { money, type Quote } from '@generated/components/pricing';

export function PriceBox({ q, title = 'Price Breakdown' }: { q: Quote; title?: string }) {
  const row = (label: string, value: string, accent = false) => (
    <div className="flex justify-between gap-4 py-1.5 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className={`tabular-nums ${accent ? 'text-primary' : ''}`}>{value}</span>
    </div>
  );
  return (
    <div className="border border-foreground bg-card p-5">
      <div className="border-b border-foreground pb-2 text-[11px] font-semibold uppercase tracking-[0.18em]">{title}</div>
      <div className="divide-y divide-border">
        {q.baseRate > 0 && (<>
          {row("Monthly rate", `${money(q.rate)}${q.papers > 1 ? " × 2 papers" : ""}`)}
          {row("Duration", `${q.months} month${q.months > 1 ? "s" : ""}`)}
          {row("Print subtotal at base rate", money(q.gross))}
        </>)}
        {q.frequencySavings > 0 && row('Frequency discount', `−${money(q.frequencySavings)}`, true)}
        {q.bundleSavings > 0 && row('Bundle savings (15%)', `−${money(q.bundleSavings)}`, true)}
        {q.prepaySavings > 0 && row('Prepayment discount (10%)', `−${money(q.prepaySavings)}`, true)}
        {q.episodes > 0 && row(`Brennan's Report — ${q.episodes} monthly episode${q.episodes > 1 ? "s" : ""}`, money(q.sponsorGross))}
        {q.packageSavings > 0 && row("Package: 6 episodes for the price of 5", `−${money(q.packageSavings)}`, true)}
        {q.comboSavings > 0 && row("Print + video discount (10%)", `−${money(q.comboSavings)}`, true)}
      </div>
      <div className="mt-3 flex items-end justify-between border-t-2 border-foreground pt-3">
        <span className="text-sm font-semibold uppercase tracking-wider">Total due</span>
        <span className="font-[family-name:var(--font-heading)] text-3xl font-semibold tabular-nums">{money(q.total)}</span>
      </div>
      <div className="mt-1 text-right text-xs text-muted-foreground">≈ {money(q.monthlyEffective)} per month</div>
    </div>
  );
}
